export enum PhoneType {
    Primary = 0,
    Alternate = 1
}


export enum UserRole {
    SuperAdmin = 0,
    Admin = 1, // Tenant
    Citizen = 2,
    Anonymous = 3,
    Juris = 4
}

export enum ValidationFlag {
    IsFutureDate = 0,
    IsCurrentOrFutureDate = 1,
    IsBetweenDate = 2,
    IsEqualOrGreaterthan = 3,
    IsEqualOrLessthan = 4
}


export enum AlertType {
    warning = 0,
    error = 1,
    configerr = 2,
    danger = 3,
    success = 4
}

export enum ParamType {
    TextBox = 1,
    Dropdown = 2,
    RadioButton = 3,
    MultiCheckbox = 4,
    AttachFile = 5,
    Checkbox = 6,
    Image = 7,
    MultiSelectDropdown = 8
}

export enum ActionType {
    Add = 1,
    Edit = 2,
    Update = 3,
    Delete = 4
}

export enum PropType {
    Article = 1,
    Boat = 2,
    Gun = 3,
    Security = 4,
    Vehicle = 5
}

export enum AccidentReportSearch {
    CaseNo = 0,
    NameOrPlate = 1
}

export enum HttpStatus {
    Success = 200,
    NotFound = 400,
    Error = 500,
    Unauthorized = 401,
}

export enum AddressStatus {
    New = 0,
    Authorized = 1,
    Denied = 2,
    Cancel = 3
}

export enum ParamId {
    GoogleMapKey = 5,
    HeaderLogoImageSize = 9,
    Logo = 10,
    CurrentLogo = 11,
    Languages = 15,
    ReportIncident = 18,
    TaxiCompliant = 19,
    CitizenRegistration = 20,
    CrimeMapDefaultPeriod = 22,
    OvernightParkingMaxDays = 30,
    OvernightParkingMaxExtDays = 31,
    PaypalOption = 35,
    AccidentReport = 41,
    PaypalClientIDsandbox = 42,
    PaypalClientIDproduction = 43,
    CrimeStatistics = 45,
    AnonymousTips = 51,
    FlagExpiry = 53,
    AllowedZipCodes=62,
    CrimeMapToDateRange = 63,
    CrimeMapMileRadius = 72,
    CrimeMapBlockedAddressDistance = 73,
    CrimeMapIsAddressBlocked = 5624,
    PaymentGatewayURL = 89,
    PaymentGatewayToken = 90,
    PaymentProviderLogin = 91,
    PaymentProviderAuthToken = 92,
    PaymentApiKey = 93,
    paymentLiveURL = 36,
    paymentSandboxURL = 37,
}

export enum OccurredDate {
    OccurredFromDate = 1,
    OccurredToDate = 2,
    OccurredAtDate = 3
}
export enum AccidentReportStatus {
    //InvalidCaseDtl = -1,
    New = 0,
    NotAvailable = 1,
    NotYetApproved = 2,
    Approved = 3,
    SameRequestAlreadyExists = 4
}
export enum ErrorMessageCodes {
    EmptyString = 0,
    InvalidCaseDtl = 1,
    InvalidPlateNo = 2,
    InvalidState = 3,
    InvalidMonth = 4,
}
export enum PermitsBasedOn {
    Days = 'D',
    Permission = 'P'
}
export enum RegStatus {
    RegisterUser = "R",
    AuthorizedUser = "A",
    NewUser="N"
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/enumtype.ts